import React from 'react';

import Building from '../../../assets/layer_types/Building.svg?react';
import Environment from '../../../assets/layer_types/Environment.svg?react';
import Pedestrian from '../../../assets/layer_types/Pedestrian.svg?react';
import Road from '../../../assets/layer_types/Road.svg?react';
import Sidewalk from '../../../assets/layer_types/Sidewalk.svg?react';

const components: Record<string, React.FC<React.SVGProps<SVGSVGElement>>> = {
  Road,
  Sidewalk,
  Pedestrian,
  Environment,
  Building,
};

interface LayerTypeIconProps {
  type: string;
  style?: React.CSSProperties;
}

export const LayerTypeIcon: React.FC<LayerTypeIconProps> = ({ type, style }) => {
  if (type === 'Unspecified') {
    const size = style?.width ?? 14;
    return (
      <svg width={size} height={size} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" style={style}>
        <rect x="3" y="7" width="10" height="2" rx="1" fill="currentColor" />
      </svg>
    );
  }
  const Component = components[type];
  return Component ? <Component style={style} /> : null;
};
